import { __LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__, __LEGACY_STOREFRONT_SESSION_LOCAL_STORAGE_KEY__, novelSessionTokenDataStorageKey, novelSessionTokenStorageKey, } from "@novel/shared/utils/appConstants";
let cacheForHasLocalStorageAccessIsSet = false;
let cachedResultForHasLocalStorageAccess;
const fallbackLocalStorage = {};
export function hasLocalStorageAccess() {
    if (cacheForHasLocalStorageAccessIsSet) {
        return cachedResultForHasLocalStorageAccess;
    }
    if (typeof window === "undefined") {
        cachedResultForHasLocalStorageAccess = false;
    }
    else {
        try {
            window.localStorage.getItem("prove_using_api_doesnt_throw");
            cachedResultForHasLocalStorageAccess = !!window.localStorage;
        }
        catch (e) {
            cachedResultForHasLocalStorageAccess = false;
        }
    }
    cacheForHasLocalStorageAccessIsSet = true;
    return cachedResultForHasLocalStorageAccess;
}
export function getFromLocalStorage(localStorageProperty) {
    let value;
    if (hasLocalStorageAccess()) {
        const fromLocalStorage = window.localStorage.getItem(localStorageProperty);
        value = isNil(fromLocalStorage) ? undefined : fromLocalStorage;
        // migrate legacy session tokens to new keys
        if (!value) {
            if (localStorageProperty === novelSessionTokenStorageKey) {
                // check legacy value
                value = getFromLocalStorage(__LEGACY_STOREFRONT_SESSION_LOCAL_STORAGE_KEY__);
                if (value) {
                    setInLocalStorage(novelSessionTokenStorageKey, value);
                    unsetInLocalStorage(__LEGACY_STOREFRONT_SESSION_LOCAL_STORAGE_KEY__);
                }
            }
            else if (localStorageProperty === novelSessionTokenDataStorageKey) {
                // check legacy value
                value = getFromLocalStorage(__LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__);
                if (value) {
                    setInLocalStorage(novelSessionTokenStorageKey, value);
                    unsetInLocalStorage(__LEGACY_STOREFRONT_SESSION_TOKEN_DATA_LOCAL_STORAGE_KEY__);
                }
            }
        }
    }
    else {
        value = fallbackLocalStorage[localStorageProperty];
    }
    return !isNil(value) && value !== "null" && value !== "undefined" ? value : undefined;
}
export function setInLocalStorage(localStorageProperty, localStorageValue) {
    if (!isNil(localStorageValue) &&
        localStorageValue !== "null" &&
        localStorageValue !== "undefined") {
        if (hasLocalStorageAccess()) {
            window.localStorage.setItem(localStorageProperty, localStorageValue);
        }
        else {
            fallbackLocalStorage[localStorageProperty] = localStorageValue;
        }
    }
}
export function unsetInLocalStorage(localStorageProperty) {
    if (hasLocalStorageAccess()) {
        window.localStorage.removeItem(localStorageProperty);
    }
    else {
        delete fallbackLocalStorage[localStorageProperty];
    }
    // a separate in-memory cache mechanism we use that we want to clear
    if (typeof window !== "undefined" && window.__novel_cache__) {
        delete window.__novel_cache__[localStorageProperty];
    }
}
// put here directly to optimize for bundle size
function isNil(value) {
    return value === null || value === undefined;
}
